import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './index.module.scss';
import { useTypingEffect, UseTypingEffectOptions } from './useTypingEffect';
import { PropsWithChildren } from 'react';
import { useMount } from 'ahooks';
import React from 'react';

// import 'github-markdown-css';

interface MarkdownBlockProps {
  markdown: string;
  enableTypingEffect?: boolean;
  typingSpeed?: number;
}

/**
 * markdown文本组件
 * @param param0
 * @returns
 */
export const MarkdownBlock: React.FC<MarkdownBlockProps> = ({ markdown }) => {
  const components = {
    a: ({ href, children, ...props }) => (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    ),
  } as React.ComponentProps<typeof Markdown>['components'];

  return (
    <div className={styles['markdown']}>
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {markdown}
      </Markdown>
    </div>
  );
};

type TypingMarkdownBlockProps = {
  /** 要展示的 markdown 文本 */
  markdown: string;
  /** 打字速度，单位毫秒/字符，默认 30ms */
  typingSpeed?: number;
  /** 打字机效果完成后的回调 */
  onTypingComplete?: () => void;
} & UseTypingEffectOptions;

/**
 * 带打字机效果的 markdown 文本组件
 * 逐字符展示内容，完成后通过 onTypingComplete 通知外部
 */
export const TypingMarkdownBlock: React.FC<TypingMarkdownBlockProps> = props => {
  const { markdown, typingSpeed = 30, onTypingComplete, defaultEnabled = true, onTyping } = props;

  const { displayedText } = useTypingEffect(markdown, {
    defaultEnabled,
    typingSpeed,
    onComplete: onTypingComplete,
    onTyping,
  });

  return (
    <div className="relative">
      <MarkdownBlock markdown={displayedText} />
    </div>
  );
};

export const NoTypingWrapper: React.FC<PropsWithChildren<Pick<TypingMarkdownBlockProps, 'onTypingComplete'>>> = ({
  onTypingComplete,
  children,
}) => {
  useMount(() => {
    onTypingComplete?.();
  });
  return <React.Fragment>{children}</React.Fragment>;
};
